export default {
  // ========== Tabs ==========
  institutional: 'Institutional',
  forThe: 'for the',

  // ========== Copy buttons ==========
  copyThe: 'Copy the',
  ofThe: 'from the',
  copyConfirmTitle: 'Copy the planning?',
  copyConfirmText:
    'Existing sessions in the target will be replaced by the copied planning.',
  copyError: 'The planning could not be copied. Please try again.',
};
